import type React from 'react';

import { AdornedInput, Adornment, FormField, FormHelp, Label } from '@zillow/constellation';
import { CurrencyInput } from '@zillow/zrs-comet';

import type { Field } from '../../../../models';
import { CURRENCY_INPUT_PLACEHOLDER } from '../../../../constants/stringConstants';

type Props = {
  label: string;
  value: string;
  onChange: (event: React.FormEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FormEvent<HTMLInputElement>) => void;
  field: Field;
  dataFieldName: string;
  perMonth: boolean;
  formHelp?: string;
};

export default function PetsCurrencyInput({ label, field, dataFieldName, perMonth, formHelp, ...rest }: Props) {
  return (
    <FormField
      label={<Label>{label}</Label>}
      error={field.hasError}
      control={
        <AdornedInput
          input={<CurrencyInput {...rest} data-field-name={dataFieldName} placeholder={CURRENCY_INPUT_PLACEHOLDER} />}
          leftAdornment={<Adornment>$</Adornment>}
          rightAdornment={perMonth && <Adornment>per month</Adornment>}
        />
      }
      description={
        <>
          {formHelp && !field.hasError && <FormHelp>{formHelp}</FormHelp>}
          {field.hasError && <FormHelp>{field.getErrorMessage()}</FormHelp>}
        </>
      }
    />
  );
}
